"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = SuccessMedium;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _SuccessMedium = require("@adobe/react-spectrum-ui/dist/SuccessMedium");

var _icon = require("@react-spectrum/icon");

var _provider = require("@react-spectrum/provider");

var _react = _interopRequireDefault(require("react"));

const ExpressIcon = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  viewBox: "0 0 18 18"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  d: "M9.014 18.001a9.68 9.68 0 0 1-.628-.021 9 9 0 0 1-5.3-15.764 9 9 0 0 1 11.829 13.568 8.934 8.934 0 0 1-5.901 2.217ZM8.99 1.999a7 7 0 0 0-5.265 11.6A7 7 0 1 0 14.276 4.4 6.947 6.947 0 0 0 9.48 2.017a6.817 6.817 0 0 0-.489-.018Zm-.83 11.26a1 1 0 0 0 .713-.395l4.924-6.546a1 1 0 0 0-1.598-1.203L7.945 10.77 5.4 8.38A1 1 0 0 0 4.03 9.838l3.36 3.154a1 1 0 0 0 .684.27.843.843 0 0 0 .086-.003Z"
}));

ExpressIcon.displayName = _SuccessMedium.SuccessMedium.displayName;

function SuccessMedium(props) {
  var _provider$theme, _provider$theme$globa;

  let provider = (0, _provider.useProvider)();
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, provider != null && (_provider$theme = provider.theme) != null && (_provider$theme$globa = _provider$theme.global) != null && _provider$theme$globa.express ? /*#__PURE__*/_react.default.createElement(ExpressIcon, null) : /*#__PURE__*/_react.default.createElement(_SuccessMedium.SuccessMedium, null));
}